import React, { useState } from "react";
import { PopUpWhiteBox } from "../../styles/boxes";
import { BlueButton, GrayButton } from "../../styles/buttons";
import QRCodeImage from "../../styles/qr/qrCode.png"; // Adjust the path based on your folder structure

interface PopUpMantencionProps {
  difference: number;
  isVisible: boolean;
  onClose: () => void;
}

const PopUpMantencion: React.FC<PopUpMantencionProps> = ({
  difference,
  isVisible,
  onClose,
}) => {
  const [isBookingView, setIsBookingView] = useState(false);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 z-50">
      <PopUpWhiteBox>
        <div className="flex flex-col items-center justify-center text-center space-y-4 fill-[#FFFF]">
          {isBookingView ? (
            <>
              <h1 className="text-2xl font-bold font-montserrat">Agenda tu Mantención</h1>
              <p className="text-sm font-montserrat">
                Lo sentimos, actualmente esta funcionalidad sólo se encuentra disponible para nuestra App.
              </p>
              <p className="text-sm font-montserrat">
                Escanea el siguiente código QR desde tu dispositivo móvil, descarga nuestra aplicación
                y agenda tu mantención de forma rápida y fácil.
              </p>
              <img
                src={QRCodeImage}
                alt="Código QR para agendar mantención"
                className="w-40 h-40"
              />
            </>
          ) : (
            <>
              <h1 className="text-2xl font-bold font-montserrat">Hora de tu mantención</h1>
              <p className="text-sm font-montserrat">
                Hace {difference} año(s) hiciste esta cotización.
                Esto significa que es momento de hacer una mantención y limpieza
                para asegurarse de que todo esté funcionando perfectamente
                y los paneles estén produciendo de la manera más óptima.
              </p>
              <p className="text-sm font-montserrat">
                Este servicio incluye limpieza de los paneles,
                verificación de conexión en paneles, tablero e inversor
                y verificación de estructura para evitar descargas eléctricas.
              </p>
              <p className="text-sm font-montserrat">
                Esto tiene un costo de 60.000 CLP.
              </p>

              <BlueButton
                label="Ir a Agendar"
                w="298px"
                h="44px"
                onClick={() => setIsBookingView(true)} // Switch to the QR code view
              />
              <GrayButton
                label="Lo haré por mi cuenta"
                w="298px"
                h="44px"
                onClick={onClose}
              />
            </>
          )}
        </div>
      </PopUpWhiteBox>
      <GrayButton
        label="Cerrar"
        icon="X"
        w="108px"
        h="44px"
        onClick={onClose}
      />
    </div>
  );
};

export default PopUpMantencion;
